import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { filter, indexOf } from 'lodash';
import AccountTable from './index';


class AccountModal extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      show,
    } = this.props;
    if (!show) {
      return null;
    }
    return (
      <AccountTable
        {...this.props.tableConfigs}
        accounts={this.props.accounts}
        enableFullScreen
        fullScreenMode
        onExitFullScreen={this.props.onClose}
        showExcluedReason={this.props.showExcluedReason}
      />
    );
  }
}


AccountModal.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.shape({
    account_id: PropTypes.string.isRequired,
  })).isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  tableConfigs: PropTypes.shape({}),
  getAccounts: PropTypes.func,
  showExcluedReason: PropTypes.bool,
};
AccountModal.defaultProps = {
  onClose: () => {},
  show: false,
  tableConfigs: {},
  getAccounts: null,
  showExcluedReason: false,
};

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const accounts = ownProps.getAccounts ? ownProps.getAccounts(state) : [];
  const newAccounts = filter(accounts, account => (indexOf(ownProps.accountIds || [], account.account_id) >= 0));
  return {
    accounts: newAccounts,
    show: newAccounts.length > 0,
  };
}

export default connect(mapStateToProps)(AccountModal);
